<script lang="ts" setup>
import BuyOneClickForm from "~/features/search/BuyOneClickForm.vue";
import Modal from "~/components/ui/modals/Modal.vue";
import PlugImage from "~/assets/icons/search/product-plug.svg?url";
import useSearchStore from "~/shared/store/modules/search";
import type {IProductInfo} from "~/shared/interfaces/search/product";

defineProps<{
  product: IProductInfo
  minPrice: number
}>()

const emits = defineEmits(['close-modal'])
const searchStore = useSearchStore()

function closeModal() {
  emits('close-modal')
}
</script>

<template>
  <Modal
    :modal-is-open="searchStore.isBuyOneClickModal"
    modal-title="Заявка на покупку"
    @close-modal="closeModal"
    full-height-on-mobile
  >
    <div class="one-click">
      <div class="one-click__product">
        <div class="one-click__product-image">
          <nuxt-img
            v-if="product.photos.length"
            :src="product.photos[0].url"
            alt=""
            loading="lazy"
          />
          <img
            v-else
            :src="PlugImage"
            alt=""
          >
        </div>
        <div class="one-click__product-container">
          <p class="one-click__product-name">{{ product.title }}</p>
          <p class="one-click__product-info">
            <span class="brand-name">{{ product.brand.name }}</span>
            <span></span>
            <span>{{ product.article }}</span>
          </p>
        </div>
      </div>
      <BuyOneClickForm
        :product="product"
        :min-price="minPrice"
      />
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
:deep(.modal-content) {
  @include xs-breakpoint {
    padding-top: 24px;
    overflow: visible !important;
  }
}
:deep(.modal-content__wrapper) {
  max-width: 352px;
  @include xs-breakpoint {
    height: 100%;
    max-width: none;
    display: flex;

  }
}

:deep(.modal-close__wrapper) {
  @include xs-breakpoint {
    top: 24px !important;
    right: 20px !important;
    width: 24px !important;
    height: 24px !important;
  }
}

.one-click {
  width: 352px;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  gap: 28px;
  @include xs-breakpoint {
    width: 100%;
    flex-grow: 1;
    display: flex;
  }

  &__title {
    @include font(24px, 28px, 600);
    @include xs-breakpoint {
      @include font(20px, 24px, 600);
    }
  }

  &__product {
    display: flex;
    align-items: center;
    gap: 16px;

    &-image {
      flex-shrink: 0;
      width: 72px;
      height: 72px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-position: center;
        object-fit: cover;
      }

      &:after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: #6262620D;
      }
    }

    &-name {
      @include font(14px, 20px);
    }

    &-info {
      display: flex;
      align-items: center;
      padding-top: 4px;
      gap: 4px;
      color: $content-secondary;
      @include font(14px, 20px);

      span:nth-child(2) {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: $content_icons;
      }
    }
  }
}
</style>
